import {styled} from 'styled-components';
import {useSearch} from 'wouter';

import {NavButton} from '@shared-web/components/core/button';

import {TeamModule} from '@src/components/team_module';
import {Team} from '@src/lib/teams';

export const ChampionsPickPage: React.FC = () => {
  const queryString = useSearch();
  return (
    <>
      <Wrapper>
        <TeamModule team={Team.Blue} />
        <TeamModule team={Team.Red} />
      </Wrapper>
      <GptButton>
        <NavButton to={`/overview?${queryString}`} overrides={{fontSize: 20, fontWeight: 'bold'}}>
          ANALYZE
        </NavButton>
      </GptButton>
    </>
  );
};
ChampionsPickPage.displayName = 'ChampionsPickPage';

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: flex-start;
  & > * {
    width: 50%;
    height: 100%;
    overflow: visible;
  }
`;

const GptButton = styled.div`
  position: fixed;
  bottom: 10vh;
  left: 50%;
  translate: -50% 0;
  z-index: 100;
`;
